import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReasonRoutingModule } from './reasons-routing.module';
import { ReasonsComponent } from './reasons.component';
import { ListReasonsComponent } from './components/list-reasons/list-reasons.component';
import { AddReasonComponent } from './components/add-new-reason/add-new-reason.component';
import { EditReasonComponent } from './components/edit-reason/edit-reason.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    ReasonRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [ReasonsComponent, ListReasonsComponent, AddReasonComponent, EditReasonComponent]
})
export class ReasonsModule {}
